import { FC } from "react";
import { formatearPesoMXN } from "../../../../../../utilis/formatter";


interface IProps {

    value?: any;
    type?: 'amount' | 'commission'
}

export const Amount: FC<IProps> = ({value, type}) => {
    


  return (
      <span className={type ?? 'amount'}>
        {  formatearPesoMXN(value)  }
      </span>
  );
};
